import { Outlet } from 'react-router';

/** `main.auth` with the rocket motif, brand and footer around the sign-in cards. */
export function AuthLayout() {
  return (
    <main className="auth">
      <img className="auth__motif" src="/assets/logo-mark.svg" alt="" aria-hidden="true" />
      <div className="auth__panel">
        <div className="auth__brand">
          <img src="/assets/logo-primary-negative.svg" alt="Open as App" />
        </div>
        <Outlet />
        <footer className="auth__foot">
          <span>Internal access only</span>
          <a href="mailto:it@openasapp.com">Contact IT</a>
        </footer>
      </div>
    </main>
  );
}
